interface Config {
    nodeEnv: string;
    baseUrl: string;
    apiUrl: string;
    feedbackUrl: string;
    enableTestFeatures: boolean;

    matomo: {
        host: string;
        siteId: string;
        enabled: boolean;
    };
}

const isDev = process.env.NODE_ENV !== 'production';
const baseUrl = process.env.AI_INSIGHTS_BASE_URL ?? '';
const apiUrl = process.env.AI_INSIGHTS_BASE_URL ?? '';
const matomoHost = process.env.MATOMO_HOST ?? '';
const matomoSiteId = process.env.MATOMO_SITE_ID ?? '';
const isMatomoEnabled = Boolean(matomoHost && matomoSiteId) && !isDev;

// Manual switch for test-only features.
// Keep this in sync with server/src/config.ts.
// Set to false before releasing to production.
// Logs a warning when enabled.
const enableTestFeatures = false as boolean;

if (enableTestFeatures) {
    // eslint-disable-next-line no-console -- deliberate, loud reminder that test-only features are live
    console.warn(
        '[AI Insights] TEST FEATURES ENABLED. Set enableTestFeatures to false in client/src/config.ts before releasing to production.'
    );
}

// TODO: Replace fallback URL
const feedbackUrl = process.env.AI_INSIGHTS_FEEDBACK_URL ?? 'https://forms.office.com/e/8pBFsVH1A0';

const config: Config = {
    nodeEnv: process.env.NODE_ENV ?? 'development',
    baseUrl: isDev ? 'http://localhost:3000' : baseUrl,
    apiUrl: isDev ? '' : apiUrl,
    feedbackUrl,
    enableTestFeatures,
    matomo: {
        host: matomoHost,
        siteId: matomoSiteId,
        enabled: isMatomoEnabled,
    },
};

export default config;
